const validateTO2 = (rule, value, callback) => {
  if (value >= 10000000) {
    callback(new Error('请输入10,000,000.00以内的数字！'));
  } else {
    callback();
  }
};
const validateTO3 = (rule, value, callback) => {
  if (value >= 10000) {
    callback(new Error('请输入10,000.00以内的数字！'));
  } else {
    callback();
  }
};
import dayjs from 'dayjs';
export function omitNumber(e) {
  let value = e;
  value = value.replace(/[^\d.]/g, ''); //清除“数字”和“.”以外的字符
  value = value.replace(/\.{2,}/g, '.'); //只保留第一个. 清除多余的
  value = value
    .replace('.', '$#$')
    .replace(/\./g, '')
    .replace('$#$', '.');
  value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
  if (value.indexOf('.') < 0 && value != '') {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    value = parseFloat(value);
  }
  if (value == '.') {
    value = '0.';
  }
  return value;
}
export const startOption = {
  column: [
    {
      type: 'input',
      label: '处理人',
      span: 24,
      display: true,
      prop: 'handleUserId',
      formslot: true,
      required: true,
      // rules: [
      //   {
      //     required: true,
      //     message: '请填写处理人'
      //   },
      // ]
    },
    {
      label: '预计完成时间',
      prop: 'estimateEndTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      span: 24,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择预计完成时间',
        },
        {
          validator: function(rule, value, cb) {
            const beforeNow = dayjs(value).isBefore(dayjs());
            if (beforeNow) {
              cb(new Error('预计完成时间需要大于当前时间'));
            } else {
              cb();
            }
          },
        },
      ],
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      // required: true,
      // rules: [
      //   {
      //     required: true,
      //     message: '请填写备注'
      //   },
      //   { min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }
      // ]
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType: 'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot: true,
      drag: true,
    },
  ],
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保存',
  emptyBtn: false,

  menuPosition: 'right',
  detail: false,
  tabs: false,
};

export const endOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'select',
      label: '服务类型',
      span: 24,
      dicData: [],
      display: true,
      dicUrl: '/api/blade-system/dict/dictionary?code=order_service_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'orderServiceType',
      required: true,
      rules: [
        {
          required: true,
          message: '请选择服务类型',
        }
      ],
    },
    {
      type: 'textarea',
      label: '其他内容',
      span: 24,
      display: false,
      required: true,
      prop: 'otherContent',
      maxlength: 200,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '请输入其他内容',
        },
        { min: 0, max: 200, message: '请控制在200个字符内！', trigger: 'change' },
      ],
    },
    {
      label: '处理时间',
      prop: 'replyOrHandleTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      span: 24,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择处理时间',
        },
        {
          // validator: function(rule, value, cb) {
          //   const beforeNow = dayjs(value).isBefore(dayjs());
          //   if (beforeNow) {
          //     cb(new Error('预计完成时间需要大于当前时间'));
          //   } else {
          //     cb();
          //   }
          // },
        },
      ],
    },
    {
      type: 'textarea',
      label: '处理情况',
      span: 24,
      display: true,
      // formslot: true,
      required: true,
      prop: 'replyOrHandleContent',
      maxlength: 1000,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '请输入处理情况',
        },
        { min: 0, max: 1000, message: '请控制在1000个字符内！', trigger: 'change' },
      ],
    },
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }],
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType: 'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot: true,
      drag: true,
    },
  ],
};

export const advisoryEndOption = {
  labelPosition: 'right',
  labelSuffix: '：',
  labelWidth: 120,
  gutter: 0,
  menuBtn: true,
  submitBtn: false,
  submitText: '保存',
  emptyBtn: false,
  emptyText: '清空',
  menuPosition: 'right',
  detail: false,
  tabs: false,
  column: [
    {
      type: 'select',
      label: '服务类型',
      span: 24,
      dicData: [],
      display: true,
      dicUrl: '/api/blade-system/dict/dictionary?code=order_service_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'number',
      prop: 'orderServiceType',
      required: true,
      rules: [
        {
          required: true,
          message: '请选择服务类型',
        }
      ],
    },
    {
      type: 'textarea',
      label: '其他内容',
      span: 24,
      display: false,
      required: true,
      prop: 'otherContent',
      maxlength: 200,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '请输入其他内容',
        },
        { min: 0, max: 200, message: '请控制在200个字符内！', trigger: 'change' },
      ],
    },
    {
      label: '回复时间',
      prop: 'replyOrHandleTime',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      span: 24,
      required: true,
      rules: [
        {
          required: true,
          message: '请选择回复时间',
        },
        {
          // validator: function(rule, value, cb) {
          //   const beforeNow = dayjs(value).isBefore(dayjs());
          //   if (beforeNow) {
          //     cb(new Error('预计完成时间需要大于当前时间'));
          //   } else {
          //     cb();
          //   }
          // },
        },
      ],
    },
    {
      type: 'textarea',
      label: '回复内容',
      span: 24,
      display: true,
      // formslot: true,
      required: true,
      prop: 'replyOrHandleContent',
      maxlength: 1000,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '请输入回复内容',
        },
        { min: 0, max: 1000, message: '请控制在1000个字符内！', trigger: 'change' },
      ],
    },    
    {
      type: 'textarea',
      label: '备注',
      span: 24,
      display: true,
      formslot: true,
      prop: 'remark',
      rules: [{ min: 0, max: 500, message: '请控制在500个字符内！', trigger: 'change' }],
    },
    {
      type: 'upload',
      label: '附件',
      span: 24,
      display: true,
      showFileList: true,
      multiple: true,
      limit: 10,
      dataType: 'array',
      propsHttp: {},
      canvasOption: {},
      prop: 'attachList',
      formslot: true,
      drag: true,
    },
  ],
};
